import React, { Component } from "reactn";
import Api from "js/core/api";
import { TextInput } from "../components";
import { Gap10, Gap20, Gap30 } from "../../../components/Gap";
import { InviteTeamMembersDialog } from "../dialogs";
import TeamMembersList from "js/react/views/UserOptions/components/TeamMembersList";
import Loadable from "js/react/components/Loadable";
import {
    Section,
    UIPane,
    UIPaneContents,
    UIPaneHeader,
    BlueButton
} from "js/react/components/UiComponents";
import { ShowDialog } from "../../../components/Dialogs/BaseDialog";
import { app } from "js/namespaces";
import { FeatureType } from "js/core/models/features";
import { ds } from "js/core/models/dataService";
import AddExistingMemberDialog from "../dialogs/AddExistingMemberDialog";
import { TEAM_USER_ROLES } from "../../../../../common/constants";
import { HelpBubblePositionType, HelpBubble } from "../../../../help/help";
import { $, _ } from "../../../../vendor";
import { trackActivity, trackState } from "js/core/utilities/utilities";
import { getUsedSeatCount } from "../UserOptionsContainer";
import styled from "styled-components";
import { Icon, IconButton } from "@material-ui/core";
import { FlexBox } from "js/react/components/LayoutGrid";
import BillingDataService from "../dataservices/billingDataService";

class ManageTeamPane extends Component {
    state = {
        org: {},
        isLoading: true,
        team: false,
        usedSeatCount: 0,
        userRole: "",
        transactionHistoryData: [],
        subscription: { items: { data: [{}] } },
        canManageTeam: app.user.features.isFeatureEnabled(FeatureType.MANAGE_TEAM, this.props.organizationId),
    };

    constructor(props) {
        super(props);
    }

    get orgTotalSeatCount() {
        const { subscription } = this.state;
        return subscription.items.data[0].quantity;
    }

    get isActiveSubscription() {
        let { subscription } = this.state;
        return subscription && !subscription.cancel_at_period_end;
    }

    async componentDidMount() {
        await this.getFreshState();
    }

    async componentDidUpdate(prevProps) {
        // org id can change if user changes workspace.
        // isDefaultTeam can change if owner switches from viewing a specific team to all team members view.
        if (this.props.organizationId !== prevProps.organizationId || prevProps.isDefaultTeam !== this.props.isDefaultTeam) {
            this.setState({ org: {}, isLoading: true });
            await this.getFreshState();
            this.setState({ isLoading: false });
        }
    }

    fetchSubscription = async () => {
        this.setState({
            subscription: await BillingDataService.fetchSubscription(this.props.organizationId)
        });
    }

    getFreshState = async () => {
        const { isDefaultTeam } = this.props;
        if (isDefaultTeam) {
            const orgResponse = await Api.organizations.get({ id: this.props.organizationId });
            this.setState({ org: orgResponse });
        }
        await this.getTeam();
        if (this.state.canManageTeam) {
            await this.fetchSubscription();
        }
        this.setState({
            isLoading: false
        });
    };

    getTeam = async () => {
        const { teamId } = this.props;
        const teamResponse = await Api.teams.get({ id: teamId });
        const teamInvitesResponse = await Api.teamInvites.get({
            type: "team",
            id: teamId
        });
        const allMembers = teamResponse.body.members.concat(teamInvitesResponse.body);
        const user = allMembers.find(member => member.id === app.user.id);
        this.setUsedSeatCount(allMembers);

        this.setState({
            originalName: teamResponse.body.name,
            team: {
                ...teamResponse.body,
                members: allMembers
            },
            userRole: user ? user.role : "",
        });
    };

    handleTeamNameChange = event => {
        const name = event.target.value;
        this.setState(prevState => ({
            team: {
                ...prevState.team,
                name
            }
        }));
    };

    handleTeamNameBlurred = async (teamId, teamName) => {
        const { handleTeamNameChange, isDefaultTeam, organizationId } = this.props;
        const { originalName } = this.state;
        const trimmedTeamName = teamName.trim();
        const trimmedOriginalName = originalName.trim();
        if (trimmedTeamName === trimmedOriginalName) {
            return;
        }
        const updatedTeam = ds.teams.find(team => team.id == teamId);
        //if an owner is part of a team the team will be part of ds.teams otherwise an API call will be made to change
        //the team name. Need to check for existence of updatedTeam in case the owner is not part of the team
        if (updatedTeam && updatedTeam.get("isDefaultTeam")) {
            Api.organizations.put({ id: organizationId }, { type: "change_name", teamId, teamName: trimmedTeamName });
            const theme = ds.sharedThemes.findWhere({ id: updatedTeam.get("sharedThemeId") });
            theme.update({ name: trimmedTeamName });
        } else if (updatedTeam) {
            updatedTeam.update({ name: trimmedTeamName });
        } else {
            await Api.teams.put({ type: "change_team_name", teamId, teamName: trimmedTeamName });
        }
        if (isDefaultTeam) {
            const props = {
                workspace_id: organizationId,
                old_organization_name: trimmedOriginalName,
                new_organization_name: trimmedTeamName
            };
            trackState({
                "organization_name": trimmedTeamName
            });
            trackActivity("Organization", "NameChanged", null, null, props, { audit: true });
        } else {
            const props = {
                workspace_id: organizationId,
                team_id: teamId,
                old_team_name: trimmedOriginalName,
                new_team_name: trimmedTeamName
            };
            trackActivity("OrgTeam", "Renamed", null, null, props, { audit: true });
        }
        this.setState(prevState => {
            return {
                ...prevState,
                team: {
                    ...prevState.team,
                    name: trimmedTeamName
                }
            };
        });

        if (isDefaultTeam && handleTeamNameChange) {
            handleTeamNameChange(teamName);
        }
    };

    setUsedSeatCount = teamMembers => {
        const usedSeatCount = getUsedSeatCount(teamMembers);
        this.setState({ usedSeatCount });
    };

    showAddMemberDialog = () => {
        const { team, usedSeatCount, org } = this.state;
        const { isDefaultTeam, organizationId } = this.props;
        const addMemberDialog = isDefaultTeam ? InviteTeamMembersDialog : AddExistingMemberDialog;
        const props = {};
        if (isDefaultTeam) {
            props.usedSeatCount = usedSeatCount;
            props.org = org;
        }
        ShowDialog(addMemberDialog, {
            organizationId,
            team,
            callback: () => this.getFreshState(),
            ...props
        });
    };

    renderSeatCount = () => {
        const { usedSeatCount, org, canManageTeam } = this.state;

        if (usedSeatCount == this.orgTotalSeatCount) {
            return <FlexBox left>You have no available Team Pro seats.&nbsp;{canManageTeam && this.isActiveSubscription && <a onClick={this.showAddMemberDialog}>Add Team Pro Seats</a>}</FlexBox>;
        }

        return `${this.orgTotalSeatCount - usedSeatCount} Team Pro ${"seat".pluralize((this.orgTotalSeatCount - usedSeatCount) > 1)} available`;
    };

    render() {
        const { handleRemoveMember, isDefaultTeam, paneClicked } = this.props;
        const { isLoading, team, canManageTeam, org } = this.state;

        return (
            <UIPane className="manage-team">
                <UIPaneHeader>
                    Manage Team
                </UIPaneHeader>
                <UIPaneContents>
                    <Loadable isLoading={isLoading}>
                        <Section>
                            <Gap10 />
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>
                                    <TextInput
                                        label={isDefaultTeam ? "ORGANIZATION NAME" : "TEAM NAME"}
                                        id="team-name"
                                        curValue={team.name}
                                        handleChange={event => this.handleTeamNameChange(event)}
                                        handleBlur={() => this.handleTeamNameBlurred(team.id, team.name)}
                                        disabled={!canManageTeam}
                                        maxLength={50}
                                    />
                                    {isDefaultTeam && canManageTeam && <SeatCount>{this.renderSeatCount()}</SeatCount>}
                                </div>
                                {isDefaultTeam && canManageTeam && this.isActiveSubscription &&
                                    <BlueButton
                                        id="add-member-button"
                                        style={{ height: 44 }}
                                        onClick={this.showAddMemberDialog}
                                    >
                                        <Icon>add</Icon>
                                        Add a member
                                    </BlueButton>
                                }
                                {!isDefaultTeam && canManageTeam &&
                                    <BlueButton
                                        id="add-member-button"
                                        style={{ height: 44 }}
                                        onClick={this.showAddMemberDialog}
                                    >
                                        <Icon>add</Icon>
                                        Add members to this team
                                    </BlueButton>
                                }
                            </div>
                        </Section>
                        <Gap20/>
                        <TeamMembersList
                            isActiveSubscription={this.isActiveSubscription}
                            organizationId={this.props.organizationId}
                            org={org}
                            team={team}
                            getTeam={this.getTeam}
                            handleRemoveMember={handleRemoveMember}
                            getFreshState={this.getFreshState}
                            totalSeatCount={this.orgTotalSeatCount}
                            isDefaultTeam={isDefaultTeam}
                            canManageTeam={canManageTeam}
                            paneClicked={paneClicked}
                        />
                    </Loadable>
                </UIPaneContents>
            </UIPane>
        );
    }
}

const SeatCount = styled.div`
  font-size: 14px;
  margin-top: 20px;         
`;

export default ManageTeamPane;
